import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs';
import {
  Activity,
  ActivityModel,
  DataEntityRowLayoutModel
} from 'src/app/models/activities';
import { DataEntityInputListComponent } from '../../data-entity-input-list/data-entity-input-list.component';

@Component({
  selector: 'wm-data-entity-row-layout-input',
  templateUrl: './data-entity-row-layout-input.component.html',
  styleUrl: './data-entity-row-layout-input.component.css',
  standalone: false
})
export class DataEntityRowLayoutInputComponent implements OnInit, AfterViewInit {
  async persistChildComponent?(): Promise<any> {
    if (this.dataEntityInputListCtl) {
      return this.dataEntityInputListCtl.persistChildComponent();
    }
    return Promise.resolve();
  }
  constructor(private _ref: ChangeDetectorRef) { }

  @Input() layoutModel: DataEntityRowLayoutModel;
  @Input() form: UntypedFormGroup;
  @Input() isReadOnly: boolean;
  @Input() applicationId: string;
  @Input() activity: Activity<ActivityModel>;
  @Output() calculateActivity: EventEmitter<{
    templateCode: string;
    calculateFormula?: boolean;
    visReq?: boolean;
  }> = new EventEmitter();
  @ViewChild('dataEntityInputList', { static: false })
  dataEntityInputListCtl: DataEntityInputListComponent

  ngAfterViewInit(): void {
    if (this.dataEntityInputListCtl) {
      this.dataEntityInputListCtl.calculateActivity.subscribe(e => {
        this.calculateActivity.emit(e);
      });
    }
  }

  calcValue(e) {
    setTimeout(() => {
      const entities = this.activity.model.getEntities();
      this.layoutModel.evaluateIsVisible(entities, this.activity).subscribe((isVisible) => {
        // Trigger change detection to ensure UI updates
        this._ref.detectChanges();
      });
    }, 10);
  }

  cancelCalculation(templateCode: string) {
    if (this.dataEntityInputListCtl) {
      this.dataEntityInputListCtl.cancelCalculation(templateCode);
    }
  }

  ngOnInit(): void {
    // Initialization logic here
    this.layoutModel.sameActivityDataEntities.forEach((value, idx) => {
      if (this.form.controls[value]) {
        this.form.controls[value].valueChanges
          .pipe(distinctUntilChanged())
          .subscribe(this.calcValue.bind(this));
      }
    });

    // Initial evaluation of visibility
    if (this.activity?.model) {
      const entities = this.activity.model.getEntities();
      this.layoutModel.evaluateIsVisible(entities, this.activity).subscribe(() => {
        this._ref.detectChanges();
      });

    }
  }
}
